import request from "utils/request";

export function loginAccount(data) {
  return request({
    url: "/apis/v1/adminLogin",
    method: "post",
    data,
  });
}

export function sendCode(data) {
  return request({
    url: "/apis/v1/sendCode",
    method: "post",
    data,
  });
}

export function resetPassword(data) {
  return request({
    url: "/apis/v1/resetPassword",
    method: "post",
    data,
  });
}

export function findAccountActivity(data) {
  return request({
    url: "/apis/sv1/findAccountActivity",
    method: "post",
    data,
  });
}

export function saveActivity(data) {
  return request({
    url: "/apis/sv1/saveActivity",
    method: "post",
    data,
  });
}

export function findAllWtbIcon() {
  return request({
    url: "/apis/sv1/findAllWtbIcon",
    method: "get",
    params: {
      type_id: 2
    },
  });
}

export function findActivityDetail(data) {
  return request({
    url: "/apis/sv1/findActivityDetail",
    method: "post",
    data
  });
}

export function deleteActivity(data) {
  return request({
    url: "/apis/sv1/deleteActivity",
    method: "post",
    data
  });
}
export function uploadImg(file) {
  const formData = new FormData();
  formData.append("file", file);

  return request({
    url: "/apis/sv1/uploadImg",
    method: "post",
    data: formData,
  });
}

export function findActivityTag(data) {
  return request({
    url: "/apis/sv1/findActivityTag",
    method: "get",
    data
  });
}

// 获取申请列表
export function getApproval(data) {
  return request({
    url: "/apis/sv1/getApproval",
    method: "get",
    params: data
  });
}

// 审批 通过或者拒绝
export function approveTransferApply(data) {
  return request({
    url: "/apis/sv1/approveTransferApply",
    method: "post",
    data,
  });
}


// 房东申请列表
export function landlordList(data) {
  return request({
    url: "/apis/sv1/landlordList",
    method: "get",
    params: data
  });
}


// 房东申请 通过
export function landlordPass(data) {
  return request({
    url: "/apis/sv1/landlordPass",
    method: "post",
    data: data
  });
}

// 房东申请 驳回
export function landlordReject(data) {
  return request({
    url: "/apis/sv1/landlordReject",
    method: "post",
    data: data
  });
}


// 管理员查询账户信息列表（分页）
export function getNonAdminUsers(data) {
  return request({
    url: "/apis/sv1/getNonAdminUsers",
    method: "get",
    params: data
  });
}


// 管理员设置权限
export function adminSetUserPermission(data) {
  return request({
    url: "/apis/sv1/adminSetUserPermission",
    method: "post",
    data: data
  });
}

// 管理员设置权限
export function sendSms(data) {
  return request({
    url: "/apis/v1/sendSMSCode",
    method: "get",
    params: data
  });
}

// 管理员手机号登录
export function smsLoginWithRedisToken(data) {
  return request({
    url: "/apis/v1/smsLoginWithRedisToken",
    method: "post",
    data: data
  });
}